import { Filter } from "model/Filter/Filter";
import { FilterContainer, FilterHeader } from "../styles";
import { FilterSelect } from "./styles";

// todo - base FilterProps ? e.g. for onChange and header
interface Props {
  filter: Filter<string>;
  header?: string;
}

export const DropdownFilter = ({ filter, header }: Props) => {
  return (
    <FilterContainer>
      {!!header && <FilterHeader>{header}</FilterHeader>}
      <FilterSelect
        value={filter.selectedValue}
        onChange={(e) => {
          filter.setSelectedValue(e.target.value);
        }}
      >
        {filter.options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </FilterSelect>
    </FilterContainer>
  );
};
